import {
  CLICKED_TI_CHALLENGE
} from './dv2Actions';

const initialState = { mcqChallenge: null };

function mcqChallengeRoot (state = initialState, action) {
  switch (action.type) {
    case CLICKED_TI_CHALLENGE:
      return { ...state, mcqChallenge: action.payload };

    default:
      return state;
  }
}

export default mcqChallengeRoot;
